import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { generateJournalhUrl } from 'shared/helpers/urls';
import { withFetch } from 'shared/hocs/withFetch';
import { toLocalized } from 'shared/helpers/locale';
import { fetchGenerations, fetchModels } from 'shared/network/journal';
import { setVideoFilters, getVideoById } from 'shared/actions/journal';
import { compareByTitle } from 'shared/helpers/arrays';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import VideoFiltersHeader from '../VideoFiltersHeader/VideoFiltersHeader';
import history from '../../../../../history';

import s from './VideoFilters.css';

const DIV_STYLE = {
  borderRadius: '4px',
  border: '1px solid #ccc',
  height: '30px',
  lineHeight: '1em',
  fontWeight: 'normal',
};

class VideoFilters extends React.Component {
  static propTypes = {
    makes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        count: PropTypes.number,
      }),
    ).isRequired,
    videoFilters: PropTypes.shape().isRequired,
    videoTopics: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    setMainFilters: PropTypes.func.isRequired,
    getSelVideo: PropTypes.func.isRequired,
    isSelVideo: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape(),
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    location: null,
    selectedTopic: null,
  };

  state = {
    models: [],
    generations: [],
  };

  componentDidMount() {
    const { videoFilters } = this.props;

    if (videoFilters) {
      const prefSearch = true;
      if (videoFilters.topic) this.handleTopicChange(videoFilters.topic, prefSearch);
      this.handleMakeChange(this.props.videoFilters.make, prefSearch);
    }
  }

  async getModels(makeId = false, prefSearch = false) {
    const transport = 1;
    const { fetch, videoFilters } = this.props;
    const { model } = prefSearch && videoFilters;

    const models = await (makeId && fetchModels(fetch, transport, makeId));
    // if makeId not selected we getting all videos
    if (models) this.setState({ models });
    if (model && models) this.handleModelChange(model, prefSearch);
  }

  async getGenerations(modelId = false, prefSearch = false) {
    const { fetch, videoFilters } = this.props;
    const { generation } = prefSearch && videoFilters;

    const generations = await (modelId && fetchGenerations(fetch, modelId));

    if (generations) this.setState({ generations });
    if (generation && generations) this.handleGenerChange(generation, prefSearch);
  }

  setSearchUrl = value => {
    const { location, locale, videoFilters } = this.props;
    const state = { ...videoFilters, ...value };
    const pathname = generateJournalhUrl({ ...state, location }, location && location.is_country);

    history.push(toLocalized(`/${pathname}/`.replace(/\/\//g, '/'), locale));
  };

  handleMakeChange = (selectedMake, prefSearch = false) => {
    const { getSelVideo, isSelVideo, videoFilters } = this.props;
    if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field

    this.setState({ models: [], generations: [] });

    const requestParams = prefSearch
      ? videoFilters
      : { make: selectedMake, model: null, generation: null, topic: videoFilters.topic };

    this.props.setMainFilters(requestParams);
    if (!prefSearch) this.setSearchUrl(requestParams);

    this.getModels(selectedMake && selectedMake.id, prefSearch);
  };

  handleModelChange = (selectedModel, prefSearch = false) => {
    const { getSelVideo, isSelVideo, videoFilters } = this.props;
    const { make, topic } = videoFilters;
    if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field

    this.setState({ generations: [] });
    const requestParams = {
      make,
      model: selectedModel,
      generation: null,
      topic,
    };

    if (!prefSearch) {
      this.props.setMainFilters(requestParams);
      this.setSearchUrl(requestParams);
    }

    this.getGenerations(selectedModel && selectedModel.id, prefSearch);
  };

  async handleGenerChange(selectedGeneration, prefSearch = false) {
    const { videoFilters, isSelVideo, getSelVideo } = this.props;
    const { make, model, topic } = videoFilters;

    const requestParams = { make, model, generation: selectedGeneration, topic };

    if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field
    if (!prefSearch) {
      this.props.setMainFilters(requestParams);
      this.setSearchUrl(requestParams);
    }
  }

  handleTopicChange = (value, prefSearch = false) => {
    const { videoFilters, isSelVideo, getSelVideo } = this.props;
    const requestParams = { ...videoFilters, topic: value };
    if (isSelVideo && !prefSearch) getSelVideo(); // clear selected video field

    if (!prefSearch) {
      this.props.setMainFilters(requestParams);
      this.setSearchUrl(requestParams);
    }
  };

  generationsRenderer = option => (
    <div className={s.generations}>
      {option.photo && <img src={option.photo} className={s.genPhoto} alt="" />}
      <span className={s.genText}>
        {option.title} ({option.year_begin}&nbsp;-&nbsp;{option.year_end})
      </span>
    </div>
  );

  render() {
    const { makes, intl, videoFilters, videoTopics } = this.props;
    const { models, generations } = this.state;
    const {
      make: selectedMake,
      model: selectedModel,
      generation: selectedGeneration,
      topic: selectedTopic,
    } = videoFilters;

    if (makes) makes.sort(compareByTitle);
    if (models) models.sort(compareByTitle);
    if (generations) generations.sort(compareByTitle);

    return (
      <div className={s.root} id="videoFilterItem">
        <VideoFiltersHeader />
        <div className={s.mainform}>
          <div className={s.filterItem}>
            <Select
              style={DIV_STYLE}
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={makes}
              labelKey="title"
              valueKey="id"
              disabled={!makes || !makes.length}
              onChange={this.handleMakeChange}
              value={selectedMake}
            />
          </div>
          <div className={s.filterItem}>
            <Select
              style={DIV_STYLE}
              placeholder={intl.formatMessage({ id: 'Модель' })}
              instanceId="model-ff"
              name="model"
              labelKey="title"
              valueKey="id"
              options={models}
              disabled={!selectedMake || !models || !models.length}
              onChange={this.handleModelChange}
              value={selectedModel}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <Select
              style={DIV_STYLE}
              instanceId="generation-ff"
              name="generation"
              placeholder={intl.formatMessage({ id: 'Поколение' })}
              labelKey="title"
              valueKey="id"
              optionRenderer={this.generationsRenderer}
              options={generations}
              disabled={!generations || !generations.length}
              onChange={this.handleGenerChange}
              value={selectedGeneration}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <Select
              style={DIV_STYLE}
              placeholder={intl.formatMessage({ id: 'По темам' })}
              instanceId="topic-ff"
              name="topic"
              labelKey="title"
              valueKey="id"
              options={videoTopics}
              onChange={this.handleTopicChange}
              value={selectedTopic}
              matchPos="start"
            />
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  setMainFilters: setVideoFilters,
  getSelVideo: getVideoById,
};

const mapStateToProps = ({ globals }) => ({
  videoFilters: globals.journal.videoFilters,
  isSelVideo: !!globals.journal.selVideoData,
  videoTopics: globals.journal.videoTopics,
  locale: globals.locale,
  location: globals.location,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(withFetch(withStyles(s)(VideoFilters))));



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/components/VideoFilters/VideoFilters.js